import { Country } from './lists.model';
import { User } from './user.model';

export class Farm {
  id: number;
  name: string;
  identifiantFms: string;
  identifiantDistributeur: string;
  address: string;
  addressExtra: string;
  postalCode: string;
  city: string;
  country: Country;
  siretCode: string;
  active: boolean;

  user: User;
}
